//ページ内リンク
$(window).on('load', function() {
  let headerHeight = $('header').outerHeight();
  let urlHash = location.hash;
  if (urlHash) {
    let position = $(urlHash).offset().top - headerHeight;
    $('html, body').animate({ scrollTop: position }, 0);
  }
});

//固定ボタン
function PageTopAnime() {
  var scroll = $(window).scrollTop();
  if (scroll >= 300){
    $('.c-fixNavi').removeClass('is-show');
    $('.c-fixNavi').addClass('is-show');
  }else{
    if($('.c-fixNavi').hasClass('is-show')){
      $('.c-fixNavi').removeClass('is-show');
    }
  }
}

$(window).scroll(function () {
  PageTopAnime();
});

jQuery(function ($) {

  $('.header_btn').on('click',function(){
    $('.header').addClass('is-active');
  });

  $('.header_close').on('click',function(){
    $('.header').removeClass('is-active');
  });

  //works-list もっと見るボタン
  const init = 4; //初期表示数
  const more = 4; //追加表示数
  const courseListItems = $('.works-list .works-list__item').length;

  // 初期表示数以降のリスト内容を非表示に
  $(".works-list li:nth-child(n+" + (init + 1) + ")").hide();

  //初期表示数以下であればMoreボタンを非表示
  $('.works-list__more').hide();
  if (courseListItems > 4) {
    $('.works-list__more').show();
  }

  // もっと見るボタンクリックで指定数表示
  $(".works-list__more").on("click", function () {
    console.log('click');
    let this_list = $(".works-list");
    this_list.find("li:hidden").slice(0, more).slideToggle();

    if (this_list.find("li:hidden").length == 0) {
      $(this).fadeOut();
    }
  });

  //ページトップ
  $('.c-returnTop').click(function () {
    $('body, html').animate({
        scrollTop: 0
    }, 500);
    return false;
  });

  //スライダー リクルート
  const recruitSwiper = new Swiper(".mv-img", {
    loop: true,
    loopAdditionalSlides: 1,
    centerdSlides: true,
    slidesPerView: 3,
    speed: 30000,
    preventInteractionOnTransition: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
  });

  //スライダー MV-left
  const mvSwiperLeft = new Swiper(".c-topMvImg__left", {
    loop: true,
    loopAdditionalSlides: 1,
    centerdSlides: true,
    slidesPerView: 2,
    speed: 30000,
    allowTouchMove: false,
    preventInteractionOnTransition: true,
    autoplay: {
      delay: 0,
      reverseDirection: true,
    },
    breakpoints: {
      768: {
        direction: 'vertical',
        slidesPerView: 4,
      },
    }
  });

  //スライダー MV-right
  const mvSwiperRight = new Swiper(".c-topMvImg__right", {
    loop: true,
    slidesPerView: 2,
    speed: 30000,
    allowTouchMove: false,
    preventInteractionOnTransition: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    },
    breakpoints: {
      768: {
        direction: 'vertical',
        slidesPerView: 4,
      },
    }
  });

  //スライダー フッターTOP
  const footerSwiperTop = new Swiper(".slideFooterTop", {
    loop: true,
    slidesPerView: 3,
    speed: 30000,
    allowTouchMove: false,
    preventInteractionOnTransition: true,
    autoplay: {
      delay: 0,
    },
    breakpoints: {
      // 768px以上の場合
      768: {
        slidesPerView: 4,
      },
    }
  });

  //スライダー フッターBOTTOM
  const footerSwiperBottom = new Swiper(".slideFooterBottom", {
    loop: true,
    slidesPerView: 3,
    speed: 30000,
    allowTouchMove: false,
    preventInteractionOnTransition: true,
    autoplay: {
      delay: 0,
      reverseDirection: true,
    },
    breakpoints: {
      // 768px以上の場合
      768: {
        slidesPerView: 4,
      },
    }
  });

  //スライダー works
  var mySwiper = new Swiper('.slideworks', {
    slidesPerView: 1.4,
    spaceBetween: 40,
    initialSlide: 0,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar", // プログレスバー
    },   
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // 768px以上の場合
      768: {
        slidesPerView: 2.2,
      },
      992:{
        slidesPerView: 2.2,
      },
    }
  });

  //会社ヒストリー位置調整
  if($('h2').hasClass('history-ttl')){
    var historyTtlPos = $('#history .history-ttl').offset().left;
    $('.history-list__wrap').css('padding-left', historyTtlPos);
    console.log(historyTtlPos);
  }

  //
  $('.recruit-list__ttl').on('click',function(){
    $(this).next('.recruit-list__wrap').slideToggle();
    $(this).toggleClass('is-hide');
  });

  //フォーム表示切り替え  
  $('[name="c-cat"]:radio').change(function () {
    if ($("input:radio[name='c-cat']:checked").val() == "求人応募") {
      $('.for-recruit').addClass('is-shown');
    } else {
      $(".for-recruit").removeClass('is-shown');
    }
  });
  
  //フォーム表示切り替え：エラー画面
  var selectedChecked = $("input[name='c-cat']:checked").val();
  if (selectedChecked == "求人応募") {
    $('.for-recruit').addClass('is-shown');
  } else {
    $(".for-recruit").removeClass('is-shown');
  }

  //フォーム表示切り替え：確認画面
  if (document.URL.match(/contact-confirm/)) {
    var selected = $("input[name='c-cat']").val();
    if (selected == "求人応募") {
      $('.for-recruit').addClass('is-shown');
    } else {
      $(".for-recruit").removeClass('is-shown');
    }
  }

  //copyright年更新
  document.getElementById("current-year").innerText = new Date().getFullYear();
});